application.register("comp-extranet", class extends Stimulus.Controller {
    connect() {
        let invoicesUrl = this.queryTarget('invoicesLoadLink').getAttribute('data-invoices-url')

        importScript(cdnjs.jquery, () => {
            $.ajax({
                url: invoicesUrl,
                method: 'POST',
                beforeSend: function() {
                    $('#invoicesLoader').show();
                    $('#extranetContent').hide();
                },
                complete: function() {
                    $('#invoicesLoader').hide();
                    $('#extranetContent').show();
                }
            })
        })
    }
});
